export const vms_gen5 = [
  { name: "VM01 Zerschneider", location: "Stratos City – Haus im Nordosten" },
  { name: "VM02 Fliegen", location: "Stratos City – Dach des Pokémon Centers" },
  { name: "VM03 Surfer", location: "Route 6 – nach Arenasieg von Cheren" },
  { name: "VM04 Stärke", location: "Pokéwood – von Regisseur empfangen" },
  { name: "VM05 Blitz", location: "Stratos City – Pokémon Center NPC" },
  { name: "VM06 Lehmbrühe", location: "Nimbasa City – gen. Arena" },
  { name: "VM07 Gebirge", location: "Victory Road – im Inneren der Höhle" }
];